import React from 'react';
import { Box, Icon, Typography } from '@drone-js/core';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { StringFormatter } from '@agoda/react-handyman';

interface OwnProps {
    voteCount: number;
}

type Props = OwnProps;

const ReviewCardVoteCount: React.FC<Props> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    if (!props.voteCount && props.voteCount === 0) {
        return null;
    }

    const voteCountText = StringFormatter.format(cms[272059], props.voteCount);

    return (
        <Box mt="16" display="flex" alignItems="center">
            <Icon id="fill.symbol.thumbs-up" size="20" color="base.default" me="8" />
            <Typography variant="caption-default" textColor="base.default">
                {voteCountText}
            </Typography>
        </Box>
    );
};

ReviewCardVoteCount.displayName = 'ReviewCardVoteCount';
export default ReviewCardVoteCount;
